import React from 'react';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
var iconStyles = xcss({
  backgroundColor: 'color.background.neutral',
  height: '20px',
  borderRadius: 'border.radius.050',
  border: '1px solid transparent',
  color: 'color.text.subtle',
  font: 'font.body.small',
  display: 'flex',
  alignItems: 'center',
  paddingInline: 'space.050',
  paddingBlock: '0'
});
export var ControlIcon = function ControlIcon() {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: iconStyles
  }, "Ctrl");
};